import $ from 'jquery'
import jQuery from 'jquery';


class Tabs {
  constructor(element) {
    if (!element) {
      return false;
    }    

    this.elem = jQuery(element);      
    this._setActive()
    this._iniTabs();       
  }
 
  _iniTabs () {  
    this.elem.find('.e-toggle ul li a').on('click', (e) =>{
      e.preventDefault();
      
      const target = $(e.currentTarget).attr('href');   
      this.elem.find('.e-toggle ul li').removeClass('active');
      this.elem.find('.s-tabs-table__table').removeClass('active');      
    
      $(e.currentTarget).parent().addClass('active');
      $(target).addClass('active');
  });
  }

  _setActive(){
    this.elem.find('.e-toggle ul li.active a').each(function(e) {
      var target = $(this).attr('href');    
      $(target).addClass('active');
    });
  }
  
 
}
export default Tabs;
